export enum DEFAULT_HOMEPAGES {
    DMI = "marketing",
    MRI = "research",
    SI = "sales",
    DS = "digital suite",
}
export enum DIGITAL_SUITE_HOMEPAGES {
    DMI = "marketing",
    MRI = "research",
}
export const DEFAULT_HOMEPAGE_PREFERENCE_KEY = "defaultHomepage";
